var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[(_vm.cause)?_c('div',[_c('CauseSingle',{attrs:{"click-handler":_vm.backToDashboard,"cause":_vm.cause}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }